import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import '../styles/about-mnh.css';
import '../styles/appointment.css';
import '../styles/schedule-table-responsive.css';
import { PhoneCall, House, Mail } from 'lucide-react';
const appointment_data = [
  {
    "id": 0,
    "service": "General Surgery",
    "doctors": ["Dr. G. S. De"]
  },
  {
    "id": 1,
    "service": "Laparoscopic And GI Surgery",
    "doctors": ["Dr. Avidip De"]
  },
  {
    "id": 3,
    "service": "Onco-Surgery",
    "doctors": ["Dr. Avidip De", "Dr. Abhijit Das"]
  },
  {
    "id": 4,
    "service": "Plastic & Reconstrucive Surgery",
    "doctors": ["Dr. Monoranjan Sow"]
  },
  {
    "id": 5,
    "service": "Pediatric Surgery",
    "doctors": ["Dr. Partha Chakraborty"]
  },
  {
    "id": 6,
    "service": "Uro - Surgery",
    "doctors": ["Dr. Barun Saha", "Dr. D. P. Das"]
  },
  {
    "id": 7,
    "service": "Obstetrics & Gynaecology",
    "doctors": ["Dr. Dalliya Roy"]
  },
  {
    "id": 8,
    "service": "Chemotherapy",
    "doctors": ["Dr. Abhijit Das", "Dr. Avisek De"]
  },
  {
    "id": 9,
    "service": "General Medicine",
    "doctors": ["Dr. Snehasis Ghosh"]
  },
  {
    "id": 10,
    "service": "Cardiology",
    "doctors": ["Dr. Snehasis Ghosh"]
  },
  // {
  //   "id": 11,
  //   "service": "Medical Gasteroenterology",
  //   "doctors": ["Dr. Vivek Choudhary"]
  // },
  {
    "id": 12,
    "service": "Radiology",
    "doctors": ["Dr. Avisek De", "Dr. Abhijit Das"]
  },
  {
    "id": 13, // changed from 12 to 13 to ensure uniqueness
    "service": "Biochemistry & Pathology",
    "doctors": ["Dr. Ranbir Singh"]
  }
];
const scheduleList=[
  {
    "id":1,
    "doctor":"Dr. G. S. De",
    "speciality":"Consultant General Surgeon",
    "day":"Every day morning, Except Sunday",
    "time":"From 11 a.m. & Evening from 6 p.m"
  },
  {
    "id":2,
    "doctor":"Dr. Avidip De",
    "speciality":"Consultant Laparoscopic & GI Onco-Surgeon",
    "day":"Every day morning, Except Sunday",
    "time":"From 10 a.m. & Evening from 6 p.m"
  },
  {
    "id":3,
    "doctor":"Dr. Abhijit Das",
    "speciality":"Consultant Medical & Radiation Oncologist",
    "day":"Every Sunday",
    "time":"from 11 a.m"
  },
  {
    "id":4,
    "doctor":"Dr. Avisek De",
    "speciality":"Consultant Radiologist",
    "day":"Every day, Except Sunday",
    "time":"Morning 8 a.m. to 2 p.m."
  },
  {
    "id":5,
    "doctor":"Dr. Barun Saha",
    "speciality":"Consultant Uro-Surgeon",
    "day":"Last Thursday of every month",
    "time":"From 6 p.m. (with prior appointment)"
  },
  {
    "id":6,
    "doctor":"Dr. D. P. Das",
    "speciality":"Consultant Uro-Surgeon",
    "day":"2nd & 4th Sunday every month",
    "time":"From 8 a.m. (with prior appointment)"
  },
  {
    "id":7,
    "doctor":"Dr. Partha Chakraborty",
    "speciality":"Consultant Paediatric Surgeon",
    "day":"Every Sunday",
    "time":"From 10 a.m."
  },
  {
    "id":8,
    "doctor":"Dr. Rana Barik",
    "speciality":"Consultant Pulmonologist",
    "day":"Every Tuesday",
    "time":"From 1 p.m."
  },
  {
    "id":9,
    "doctor":"Dr. Monoranjan Sow",
    "speciality":"Consultant Plastic & Reconstructive Surgeon",
    "day":"Every Sunday",
    "time":"From 10 a.m."
  },
  {
    "id":10,
    "doctor":"Dr. Snehasis Ghosh",
    "speciality":"Consultant General Physician & Cardiologist",
    "day":"Every Tuesday & Friday",
    "time":"From 8 a.m."
  },
  {
    "id":11,
    "doctor":"Dr. Somenath Das",
    "speciality":"Consultant Dermatologist",
    "day":"Every Thursday & Saturday",
    "time":"From 1 p.m."
  },
  {
    "id":12,
    "doctor":"Dr. Ranbir Singh",
    "speciality":"Consultant Pathologist",
    "day":"Every Sunday",
    "time":"From 1 p.m."
  },
  {
    "id":13,
    "doctor":"Dr. Jitamanyu Maity",
    "speciality":"Consultant Neuro Psychiatrist",
    "day":"",
    "time":"By appointment"
  },
  {
    "id":14,
    "doctor":"Dr. Dalliya Roy",
    "speciality":"Consultant Obstetrician & Gynaecologist",
    "day":"Every Monday to Wednesday",
    "time":"By appointment"
  },
  {
    "id":15,
    "doctor":"Sritama Banerjee",
    "speciality":"Consultant Clinical Dietitian, Nutritionist & Diabetes Educator",
    "day":"Every Monday to Wednesday",
    "time":"By appointment"
  }
]

function Appointment() {
  const [selectedService, setSelectedService] = useState("");
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [appoType, setAppoType] = useState("newPatient");
  const [bestTime, setBestTime] = useState("Morning");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const { setValue } = useForm();
  const [captchaToken, setCaptchaToken] = useState("");

  const onHCaptchaChange = (token) => {
  setCaptchaToken(token);
};

  const [form, setForm] = useState({
    form_name: "",
    form_mobile: "",
    form_email: "",
    pin: "",
    city: "",
    address: ""
  });
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const handleServiceChange = (e) => {
    const serviceName = e.target.value;
    setSelectedService(serviceName);
    const found = appointment_data.find((item) => item.service === serviceName);
    setDoctorOptions(found ? found.doctors : []);
    setSelectedDoctor("");
  };
  const handleDoctorChange = (e) => {
    setSelectedDoctor(e.target.value);
  };

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    return (
      form.form_name.trim() &&
      form.form_mobile.trim() &&
      form.form_email.trim() &&
      selectedService &&
      selectedDoctor &&
      selectedDate &&
      form.pin.trim() &&
      form.city.trim() &&
      form.address.trim()
    );
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleAppoTypeChange = (e) => {
    setAppoType(e.target.value);
  };

  const handleBestTimeChange = (e) => {
    setBestTime(e.target.value);
  };

  // Toast helper
  const showToast = (type, message) => {
    setAlert({ show: true, type, message });
    setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3500);
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!validateForm()) {
    //   showToast('danger', 'Please fill all fields correctly.');
    //   return;
    // }
    if (!captchaToken) {
     showToast('danger', 'Please complete captcha.');
     return;
   }


    const data = new FormData();
    data.append("access_key", "5a1a2686-9d7f-4f77-b37e-2b4d7082f111");
    data.append("from_name", form.form_name);
   data.append("from_email", form.form_email);
   data.append("subject", `Appointment request from ${form.form_name}`);
   
   data.append("message", `Please set a ${appoType} appointment with ${selectedDoctor} on ${selectedDate}. Call me at ${form.form_mobile} during ${bestTime}.

    Service: ${selectedService}
    Doctor: ${selectedDoctor}
    Date: ${selectedDate}
    App Type: ${appoType}
    Time: ${bestTime}
    Mobile: ${form.form_mobile}
    Pin: ${form.pin}
    City: ${form.city}
    Address: ${form.address}`);
    data.append("h-captcha-response", captchaToken);

    try{
    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: data
    });

    const json = await res.json();
    if (json.success) {
      showToast('success', 'Successfully sent your mail');
    } else {
      showToast('danger', 'Failed to send!');
    }
    } catch (err) {
      showToast('danger', 'Unable to send mail. Please try again');
    }
    
  };

  return (
    <>
      <div className="appointment-container">
        <img
          src={require("../assets/img/waiting-room.png")}
          alt="Waiting Room"
        />
        <div className="gallery-overlay-title">
          Your Health, Our Priority
          <p style={{ fontWeight: 'normal', fontSize: '40px', color: '#FFFFFF', textAlign: 'center' }}>Accessible care, clear communication, and dependable medical support.</p>
        </div>
      </div>
      <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff" />
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
      <section className="appointment-form-section" style={{ marginTop: '40px', marginBottom: '40px' }}>
        <div className="schedule appointment-form-row schedule-hide-mobile-block">
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ marginTop: '12px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 0 0 1px #e5e7eb', minWidth: '700px', maxWidth: '1000px', width: '100%' }}>
              <table className="" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '14px', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                  <tr style={{ background: '#e5e7eb', fontWeight: 'bold' }}>
                    <th style={{ textAlign: 'left', padding: '8px', border: 'none', fontWeight: 'normal' }}>Doctor</th>
                    <th style={{ textAlign: 'left', padding: '8px', border: 'none', fontWeight: 'normal' }}>Speciality</th>
                    <th style={{ textAlign: 'left', padding: '8px', border: 'none', fontWeight: 'normal' }}>Day</th>
                    <th style={{ textAlign: 'left', padding: '8px', border: 'none', fontWeight: 'normal' }}>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {scheduleList.map((row, idx) => (
                    <tr
                      key={row.id}
                      style={{
                        background: idx % 2 === 0 ? '#DBEDF8' : '#FFFFFF',
                        borderBottom: '1px solid #e5e7eb',
                      }}
                    >
                      <td style={{ textAlign: 'left', padding: '8px', fontWeight: 'normal', border: 'none' }}>{row.doctor}</td>
                      <td style={{ textAlign: 'left', padding: '8px', fontWeight: 'normal', border: 'none' }}>{row.speciality}</td>
                      <td style={{ textAlign: 'left', padding: '8px', fontWeight: 'normal', border: 'none' }}>{row.day}</td>
                      <td style={{ textAlign: 'left', padding: '8px', fontWeight: 'normal', border: 'none' }}>{row.time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        
        <div className="appointment-form-row">
          <h1>Make an Appointment</h1>
        </div>
        <div className="appointment-form-row">
          <div className="appointment-form-col">
            <form className="appointment-form" onSubmit={handleSubmit}>
              {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                  {alert.message}
                  <button type="button" className="btn-close" aria-label="Close" onClick={() => setAlert({ ...alert, show: false })}></button>
                </div>
              )}
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <select className='dept form-select form-select-lg mb-3' value={selectedService} onChange={handleServiceChange}>
                    <option value="">Select Department</option>
                    {appointment_data.map((service) => (
                      <option key={service.id} value={service.service}>{service.service}</option>
                    ))}
                  </select>
                </div>
                <div className="appointment-form-inner-col">
                  <select className='doc form-select form-select-lg mb-3' value={selectedDoctor} onChange={handleDoctorChange}>
                    <option value="">Select Doctor</option>
                    {doctorOptions.map((doc, idx) => (
                      <option key={idx} value={doc}>{doc}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <input type="text" placeholder="Your Name" name="name" value={form.name} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
                <div className="appointment-form-inner-col">
                  <input type="text" placeholder="Your Mobile Number" name="mobile" value={form.mobile} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
              </div>
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <input type="email" placeholder="Your Email" name="email" value={form.email} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
                <div className="date appointment-form-inner-col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
                  <input
                    type="date"
                    className="form-control form-control-lg mb-3"
                    value={selectedDate}
                    onChange={handleDateChange}
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <input type="text" placeholder="Pin Code" name="pin" value={form.pin} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
                <div className="appointment-form-inner-col">
                  <input type="text" placeholder="City" name="city" value={form.city} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
              </div>
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <input type="text" placeholder="Address" name="address" value={form.address} onChange={handleInputChange} className="form-control form-control-lg mb-3" />
                </div>
              </div>
              <div className="appointment-form-inner-row">
                <div className="appointment-form-inner-col">
                  <select
                    className='doc form-select form-select-lg mb-3'
                    value={bestTime}
                    onChange={handleBestTimeChange}
                  >
                    <option value="">Select Best Time to Call</option>
                    <option value="Morning">Morning</option>
                    <option value="Afternoon">Afternoon</option>
                    <option value="Evening">Evening</option>
                  </select>
                </div>
                <div className="appointment-form-inner-col">
                  <select
                    className='doc form-select form-select-lg mb-3'
                    value={appoType}
                    onChange={handleAppoTypeChange}
                  >
                    <option value="">Select Appointment Type</option>
                    <option value="newPatient">A New Patient Appointment</option>
                    <option value="routineCheckup">A Routine Checkup</option>
                    <option value="comprehensiveHealthExam">A Comprehensive Health Exam</option>
                  </select>
                </div>
                 
              </div>
              <div className="appointment-form-inner-row">
                <HCaptcha
                  sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2"
                  reCaptchaCompat={false}
                  onVerify={onHCaptchaChange} 
                />
              </div>
              <div className="appointment-form-inner-row" style={{ marginTop: '10px' }}>
                <div className="appointment-form-inner-col" style={{ textAlign: 'right', width: '100%' }}>
                  <button type="submit" className="btn btn-primary btn-lg">Book Now</button>
                </div>
              </div>
            </form>

          </div>
          <div className="appointment-form-col ImgResp">
            <img
              src={require("../assets/img/reseption.png")}
              alt="Reception"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius:'8PX' }}
            />
          </div>
        </div>
      </section>
      <hr />
    </>
  );
}

export default Appointment;
